var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 41,
    viewBox: "0 0 62 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.1378 20.4415C61.1378 20.9735 60.9296 21.4837 60.559 21.8598C60.1884 22.2359 59.6858 22.4473 59.1617 22.4473H7.37978L21.8058 37.0639C22.1769 37.4442 22.385 37.9578 22.385 38.493C22.385 39.0282 22.1769 39.5418 21.8058 39.9221C21.4281 40.2928 20.9232 40.5 20.3978 40.5C19.8723 40.5 19.3675 40.2928 18.9897 39.9221L1.20426 21.8706C0.833176 21.4903 0.625 20.9768 0.625 20.4415C0.625 19.9063 0.833176 19.3927 1.20426 19.0125L18.9897 0.961004C19.3737 0.641166 19.8612 0.477716 20.3573 0.502447C20.8534 0.527177 21.3227 0.73832 21.6739 1.09481C22.0252 1.45129 22.2332 1.92763 22.2576 2.43117C22.2819 2.93471 22.1209 3.42945 21.8058 3.81915L7.37978 18.4358H59.1617C59.6858 18.4358 60.1884 18.6471 60.559 19.0233C60.9296 19.3994 61.1378 19.9096 61.1378 20.4415Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrowBack.bf3ee17a0a90d6781c38a99d84ec6074.svg";
export { ForwardRef as ReactComponent };